import { LocationResponseDto, VariantRequestDto } from '@tiendanube/common';
import { LanguagesType } from 'App/i18n';
import { getCreateVariantPayload } from './getCreateVariantPayload';
import { getDeleteVariantPayload } from './getDeleteVariantPayload';
import { getUpdateVariantPayload } from './getUpdateVariantPayload';
import { Variant } from '../../pages/components/Variants/types';

export const variantPayloadBuilder = {
  create: (
    variant: VariantRequestDto,
    language: LanguagesType,
    mainLocation?: LocationResponseDto,
  ) => getCreateVariantPayload(variant, language, mainLocation),
  update: (
    originalVariant: Variant,
    newVariant: VariantRequestDto,
    language: LanguagesType,
  ) => getUpdateVariantPayload(originalVariant, newVariant, language),
  delete: (variantId: string) => getDeleteVariantPayload(variantId),
};
